
import "./colorChanger.css";
import { adminColors } from '../../dataSets/adminColors';

export default function ColorChanger({ setColors}) {
  return (
    <div className='colorChanger' style={{width:`${50 * Object.entries(adminColors).length}px`}}>
        {Object.entries(adminColors).map(([key, value])=>{
            return <div key={`colorChanger_key_${key}`} className='colorChanger_item' style={{background:` linear-gradient(135deg, ${value.primary_color}, ${value.secondary_color}, ${value.accent_color})`}} onClick={()=>{setColors(adminColors[key])}}></div>
        })}
    </div>
  )
}
